import { render, staticRenderFns } from "./infrastructure.vue?vue&type=template&id=7463ce7b&scoped=true"
import script from "./infrastructure.vue?vue&type=script&lang=js"
export * from "./infrastructure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7463ce7b",
  null
  
)

export default component.exports